var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"miniature-data"},[_c('div',{staticClass:"miniature-grid-bg",style:(_vm.backgroundStyle)}),(_vm.miniature)?_c('img',{attrs:{"src":_vm.miniature}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }